import { useAppStore } from "@/providers/app";
import React, { useEffect } from "react";
import Cookies from "js-cookie";

const ScreenWidth = () => {
  const token = Cookies.get("ACCESS_TOKEN");
  const setAppState = useAppStore((state) => state.setAppState);
  const getUserData = useAppStore((state) => state.getUserData);

  const checkViewport = () => {
    const isMobileView = window.matchMedia("(max-width: 767px)").matches;
    setAppState({ isMobileView: isMobileView });
  };

  useEffect(() => {
    if (token) {
      getUserData(token);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    checkViewport();
    window.addEventListener("resize", checkViewport);
    return () => {
      window.removeEventListener("resize", checkViewport);
    };
  }, []);
  return null;
};

export default ScreenWidth;
